import { Component, forwardRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss'],
  providers: [{ provide: InputBaseComponent, useExisting: forwardRef(() => InputTextareaComponent) }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputTextareaComponent extends InputBaseComponent implements OnInit {

  @Input() public placeholder: string = '';
  @Input() public rows: number = 3;

  constructor() {
    super();
  }

  public override ngOnInit(): void {
    super.ngOnInit();
  }

}
